import { Staff } from "./IAuth";
import { Visit } from "./IServiceUser";

export enum RosterView {
  SERVICE = "service",
  STAFF = "staff",
}

export enum CalendarView {
  DAY = "resourceTimelineDay",
  WEEK = "resourceTimelineWeek",
  INACTIVE = "inactive",
}

export enum TASK {
  CHECK_IN = "check-in",
  CHECK_OUT = "check-out",
}

export interface CheckInCheckOut {
  _id: string;
  visitId: Omit<Visit, "serviceUser"> & {
    serviceUser: string | null;
  };
  carer: string;
  manuallyDoneBy?: string;
  checkInNote?: string;
  checkOutNote?: string;
  checkIn: Date;
  checkOut: Date;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface CheckInCheckOutLog {
  _id: string;
  visitId: string;
  carer: string;
  manuallyDoneBy?: string;
  checkInNote?: string;
  checkOutNote?: string;
  checkIn: Date;
  checkOut: Date;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface CheckInCheckOutByID {
  _id: string;
  visitId: Omit<Visit, "serviceUser"> & {
    serviceUser: string | null;
  };
  carer: Staff;
  manuallyDoneBy?: string;
  checkInNote?: string;
  checkOutNote?: string;
  checkIn: Date;
  checkOut: Date;
  lateOrEarlyCheckoutReason?: string;
  lateOrEarlyCheckoutReasonNote?: string;
  createdAt: Date;
  updatedAt: Date;
  __v: number;
}

export interface StaffWithLogCount extends Staff {
  logCount: number;
}
